import React from "react";
import {observer} from "mobx-react";
import {PaymentCardIcon} from "../../../../assets/svg/payment-card.icon";
import styled from "styled-components";
import { testId } from "../../../../utils/testids";

const ContainerBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${props => props.theme.spacing.flexGap8};
    padding: ${props => props.theme.spacing.spacing16};
    ${props => props.theme.containerMediaQuery.smallScreen} {
        flex-direction: column;
    }
`

const LabelBox = styled.span`
    white-space: nowrap;
    ${props => props.theme.containerMediaQuery.smallScreen} {
        position: absolute;
        bottom: 0;
        transform: translateY(-50%);
        font-size: ${props => props.theme.fontSize.body2};
        font-weight: ${props => props.theme.fontWeight.medium};
    }
`

export const CardPaymentMethodsTabHeaderComponent: React.FC = observer(() => {

    return (
        <ContainerBox {...testId("card-payment")}>
            <PaymentCardIcon size={1.6} />
            <LabelBox>
                Card
            </LabelBox>
        </ContainerBox>
    )
})